import React from "react";
import CardBadge from "../../component-library/CardBadge/CardBadge";
import CardStatus from "../../component-library/CardMeta/CardStatus";
import CardWrapper from "../../component-library/CardWrapper";
import CardShortContent from "./CardShortContent";
import CardShortSvg from "./CardShortSvg";
import CardShortText from "./CardShortText";
import CardShortFooter from "./CardShortFooter";
import PropTypes from "prop-types";
import useHideElementsIfNoHasSupport from "../../hooks/useHideElementsIfNoHasSupport";

const CardShort = ({
  id = 1,
  layoutVariation = "default",
  children = null,
  className = "",
  cardClassName = ""
}) => {
  // Hide elements when :has is not supported
  useHideElementsIfNoHasSupport();

  return (
    <CardWrapper
      cardType="short"
      layoutVariation={layoutVariation}
      id={`CardShort-${id}`}
      className={cardClassName}
    >
      {children}
    </CardWrapper>
  );
};

CardShort.propTypes = {
  type: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default Object.assign(CardShort, {
  Status: CardStatus,
  Content: CardShortContent,
  Footer: CardShortFooter,
  Text: CardShortText,
  Svg: CardShortSvg,
  Badge: CardBadge
});
